export const Environment = {
  // StakingContract: "0xF79e310a534feF41466750D81558311659E31d70",
  // TokenContract: "0x52C2c95822100298Dc090EbB1DB7Cb6a70849d28",
  StakingContract: "0x8f8e2BCA5ddA0825B1601Cb64e4D00Ec6b897fE3",
  TokenContract: "0x887D9c01FFf04022da9c6D64a65a481a9e5D1FCa",
  RouterContract: "0x765277EebeCA2e31912C9946eAe1021199B39C61",
  EthContract: "0xC741f06082AA47F93729070aD0dD95E223Bda091",
  BscContract: "0x887D9c01FFf04022da9c6D64a65a481a9e5D1FCa",
};
